export enum Action {
  /** The claim was authorized for payment. */
  AUTHORIZED = 'AUTHORIZED',

  /** A previous authorization was reversed. */
  REVERSED = 'REVERSED',
}
